import { NavLink } from 'react-router-dom';

import { ROUTES } from 'constants/routes.constant';

import ModalPortal from 'components/modal/ModalPortal';

import { ReactComponent as TrafficCone } from 'assets/traffic-cone.svg';

const StoppedSalesModal = () => {
  return (
    <ModalPortal className="tw-z-[9]">
      <div className="tw-flex tw-max-w-xs tw-flex-col tw-items-center tw-gap-5 tw-rounded-2xl tw-p-3.5 tw-pt-0">
        <TrafficCone className="tw-pb-5" />
        <h2 className="tw-text-[32px]/[28px] tw-font-bold tw-uppercase tw-text-white">Sales stopped</h2>
        <div className="tw-rounded-lg tw-border-dashed tw-border-turquoise tw-bg-turquoise tw-bg-opacity-20 tw-px-4.5 tw-py-3.5">
          <h3 className="tw-text-center tw-font-bold tw-uppercase tw-text-[18px/20px] tw-text-turquoise">
            Digital assets sales on this page are currently switched OFF
          </h3>
        </div>
        <p className="tw-text-center tw-text-white">
          You can only get digital assets by purchasing{' '}
          <NavLink to={ROUTES.LOOTBOX} className="tw-text-white tw-underline">
            Lootboxes
          </NavLink>{' '}
          or directly on{' '}
          <NavLink to={ROUTES.MARKET} className="tw-text-white tw-underline">
            Marketplace
          </NavLink>
          .
        </p>
      </div>
    </ModalPortal>
  );
};

export default StoppedSalesModal;
